import clsx from 'clsx'

import { Skeleton } from './Skeleton'

export type PageSearchFilterRowSkeletonProps = {
  className?: string
}

/**
 * Linha busca + botão de filtro avançado (`SearchInput` + ícone quadrado).
 */
export const PageSearchFilterRowSkeleton = ({
  className
}: PageSearchFilterRowSkeletonProps) => (
  <div
    className={clsx('flex min-w-0 items-center gap-2', className)}
    aria-hidden
  >
    <Skeleton
      variant="thumb"
      className="h-[var(--btn-h-md)] min-w-0 flex-1"
    />
    <Skeleton
      variant="thumb"
      className="size-[var(--btn-h-md)] shrink-0"
    />
  </div>
)
